export const ICONS_PREFIX = 'bta-icon-';
export const getIconClass = (iconID: string): string => ICONS_PREFIX + iconID;
